export enum ToastSeverity {
    info,
    warn,
    error,
    success
}

export type ToastMessage = {
    // Заголовок
    title: string;
    // поддерживает форматный вывод `Some {{var}} with some {{value}}`. Подстановка значения по ключу из bodyVars
    body: string;
    // Важность|уровень
    severity: ToastSeverity,    
    // set zero to no hiding toast
    autoHide?: number,
    // link to related entity
    actionLink?: string
}

type ToasCallback = (t: ToastMessage) => void;

type ToasManagerType = {
    onToast: (c: ToasCallback) => void;
    unsub: (c: ToasCallback) => void;
    publish: (t: ToastMessage) => void;
}

const callbacks = new Set<ToasCallback>();

// Менеджер тостов.
// Дает возможность подписаться на сообщение в обобщенном формате и произвести с ним действия
// Полезно для отрисовки тостов, использования как шины событий
const toastManager: ToasManagerType = {

    // Подписка на тост (нужно для рендерера тостов)
    onToast(callback: (t: ToastMessage) => void) {
        console.debug("новая подписка на тосты");
        callbacks.add(callback);
    },

    // Отписка
    unsub(callback: (t: ToastMessage) => void) {
        callbacks.delete(callback);
    },

    // Публикация тоста для подписчиков
    publish(toast: ToastMessage) {

        console.log("START INVOKE Callbacks: " + callbacks.size)

        for (let c of callbacks.values()) {
            c(toast);
        }
        console.log("DONE INVOKE")
    }
}

// Шаринг единственного инстанса менеджера тостов через window
const ToastManagerInstanceGet = () => {
    if (typeof window === 'undefined') {
        return toastManager;
    }

    if (!(window as unknown as any).toastManager) {
        (window as unknown as any).toastManager = toastManager;
        return toastManager;
    }
    else {
        return (window as unknown as any).toastManager as ToasManagerType;
    }
}

// Ссылка на расшаренный тост менеджер
export const ToastManagerInstance = ToastManagerInstanceGet();

// Шорткат на метод отправки тоста
export const publishToast = (toast: ToastMessage) => {
    ToastManagerInstance.publish(toast);
}